import React from 'react';
import { PageContainer, PageHeader } from '../../ui/components';
import { Icon } from '../../ui/icons';
import { useProperty } from '../../app/PropertyContext';
import { useT } from '../../i18n';
import MenuNavTabs from './MenuNavTabs';
import RecipeCategoriesTab from './RecipeCategoriesTab';

export default function RecipeCategoriesPage() {
  const t = useT();
  const { hasPermission } = useProperty();
  const canManage = hasPermission('recipes.manage');

  return (
    <PageContainer size="full">
      <PageHeader
        title={t('Menu categories')}
        description={t('Group recipes and menu items into sections (e.g. Appetizers, Mains, Desserts) used across recipes and menu engineering.')}
        icon={<Icon.Folders size={22} />}
      />

      <MenuNavTabs active="categories" />

      <RecipeCategoriesTab canManage={canManage} />
    </PageContainer>
  );
}
